import Vue from 'vue'
import VueRouter from 'vue-router'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const routes = [
    {
        //默認地址
        path: '/',
        component: () => import('@/views/home/home.vue'),
        children: [{
            path: "/",
            name: 'home',
            component: () => import('@/views/home/home.vue'),
        }]
    },
    {
        path: "/explore",
        name: 'explore',
        component: () => import('@/views/explore/explore.vue'),
    },
    {
        path: "/book-now",
        name: 'book_now',
        component: () => import('@/views/book_now/book_now.vue'),
    },
    {
        path: "/deal",
        name: 'deal',
        component: () => import('@/views/deal/deal.vue'),
    },
    {
        path: "/about-us",
        name: 'aboutus',
        component: () => import('@/views/aboutus/aboutus.vue'),
    },
    {
        path: "/contact-us",
        name: 'contactus',
        component: () => import('@/views/contactus/contactus.vue'),
    },
    {
        path: "/venues",
        name: 'venues',
        component: () => import('@/views/venues/venues.vue'),
    },
    {
        path: "/linda",
        name: 'linda',
        component: () => import('@/views/services/services.vue'),
    },
    {
        path: "/activity",
        name: 'activity',
        component: () => import('@/views/services/services.vue'),
    },
    {
        path: "/course",
        name: 'course',
        component: () => import('@/views/services/services.vue'),
    },
    {
        path: "/competition",
        name: 'competition',
        component: () => import('@/views/services/services.vue'),
    },
    {
        //內頁地址
        path: '/inside',
        name: 'insidepage',
        redirect: '/list',
        component: () => import('@/views/insidepage/insidepage.vue'),
        children: [{
            path: "/list",
            name: 'list',
            component: () => import('@/views/insidepage/pages/list/list.vue')
        }, {
            path: "/stadium/:id",
            name: 'stadium',
            component: () => import('@/views/insidepage/pages/stadium/stadium.vue')
        }, {
            path: "/linda/:id",
            name: 'linda',
            component: () => import('@/views/insidepage/pages/linda/linda.vue')
        }, {
            path: "/course/:id",
            name: 'course',
            component: () => import('@/views/insidepage/pages/course/course.vue')
        }, {
            path: "/service/:id",
            name: 'service-detail',
            component: () => import('@/views/insidepage/pages/service-detail/service-detail.vue')
        }, {
            path: "/course/confirm/:id",
            name: 'course-confirm',
            component: () => import('@/views/insidepage/pages/course/confirm/confirm.vue')
        }, {
            path: "/stadium/confirm/:id",
            name: 'stadium-confirm',
            component: () => import('@/views/insidepage/pages/stadium/confirm/confirm.vue')
        }, {
            path: "/service/confirm/:id",
            name: 'service-confirm',
            component: () => import('@/views/insidepage/pages/service-detail/confirm/confirm.vue')
        }, {
            path: "/my",
            name: 'my',
            redirect: '/my/wallet',
            component: () => import('@/views/insidepage/pages/my/my.vue'),
            children: [{
                path: "wallet",
                name: 'wallet',
                component: () => import('@/views/insidepage/pages/my/wallet/wallet.vue')
            }, {
                path: "points",
                name: 'points',
                component: () => import('@/views/insidepage/pages/my/invest/invest.vue')
            }, {
                path: "basicinfo",
                name: 'basicinfo',
                component: () => import('@/views/insidepage/pages/my/basicinfo/basicinfo.vue')
            }, {
                path: "invoice",
                name: 'invoice',
                component: () => import('@/views/insidepage/pages/my/invoice/invoice.vue')
            }, {
                path: "collection",
                name: 'collection',
                component: () => import('@/views/insidepage/pages/my/collection/collection.vue')
            }, {
                path: "message",
                name: 'message',
                component: () => import('@/views/insidepage/pages/my/message/message.vue')
            }, {
                path: "points/transfer/:code",
                name: 'points-transfer',
                component: () => import('@/views/insidepage/pages/my/points-transfer/points-transfer.vue')
            }, {
                path: "points/transfer/confirm/:code",
                name: 'points-transfer-confirm',
                component: () => import('@/views/insidepage/pages/my/points-transfer-confirm/points-transfer-confirm.vue')
            }]
        }, {
            path: "/myorder/:id",
            name: 'myorder',
            component: () => import('@/views/insidepage/pages/myorder/myorder.vue')
        }, {
            path: "/myorder/transfer/confirm/:id",
            name: 'myorder-transfer-confirm',
            component: () => import('@/views/insidepage/pages/myorder/myorder-transfer-confirm.vue')
        }, {
            //聯絡我們
            path: "/contactus",
            name: 'contactus',
            component: () => import('@/views/insidepage/pages/contactus/contactus.vue')
        }, {
            //品牌回饋活動
            path: "/feedback",
            name: 'feedback',
            component: () => import('@/views/insidepage/pages/feedback/feedback.vue')
        }, {
            //品牌回饋活動
            path: "/feedback/:id",
            name: 'feedback-details',
            component: () => import('@/views/insidepage/pages/feedback/feedback-details.vue')
        }, {
            //介紹
            path: "/introduce",
            name: 'introduce',
            component: () => import('@/views/insidepage/pages/introduce/introduce.vue')
        }]

    },
    {
        path: "/line/callback",
        name: 'line-callback',
        component: () => import('@/views/security/line/callback.vue'),
    },
    {
        path: "/tappay_demo",
        name: 'tappay_demo',
        component: () => import('@/views/tappay_demo/tappay_demo.vue'),
    },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 };
        }
    }
})


router.beforeEach((to, from, next) => {
    document.title = to.meta.title || 'PaiSport';
    next();
});

export default router